import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import PlatformFooter from '../../components/PlatformFooter';
import { useComsAvailability } from '../../context/ComsContext';

// Module placement for the staff panel — cip_staff has read access across
// platform tools but does not manage tenant or user records.
const NAV = [
  { to: '/dashboard',   label: 'Dashboard' },
  { to: '/coms',        label: '💬 Coms Hub' },
  {
    label: 'Settings',
    children: [
      { to: '/assessments', label: 'Assessments' },
      { to: '/reports',     label: 'Reports' },
      { to: '/pipeline',    label: 'Pipeline' },
    ],
  },
  { to: '/lenses',            label: '🔭 Lenses' },
  { to: '/seven-gen',         label: '🏹 7-Gen Planning' },
  { to: '/land-intelligence', label: '🌐 Land Intelligence' },
  { to: '/land-units',        label: '🗻 Land Units' },
];

const StaffShell = () => {
  const { comsEnabled } = useComsAvailability();

  return (
  <div className="shell shell--staff">
    <Navbar navItems={NAV.filter(({ to }) => comsEnabled || to !== '/coms')} />
    <main className="shell-content--full">
      <Outlet />
    </main>
    <PlatformFooter />
  </div>
  );
};

export default StaffShell;
